import React from "react";
import {
  List,
  Card,
  Button,
  Avatar,
  Icon,
  Progress,
  Popconfirm,
  Tag
} from "antd";
const { Meta } = Card;
export function TechnicalSkillsList({
  technicalSkills,
  item,
  showModal,
  editSkill,
  deleteItem
}) {
  const confirm = index => e => {
    deleteItem(index);
  };
  return (
    <List
      grid={{
        gutter: 8,
        xs: 1,
      sm: 1,
      md: 1,
      lg: 3,
      xl: 3,
      xxl: 3,
      }}
      dataSource={[
        {},
        ...Object.keys(technicalSkills).map((el, index) => {
          return {
            ...technicalSkills[el],
            index
          };
        })
      ]}
      renderItem={item => {
        if (item && item.projectName) {
          return (
            <List.Item key={item.projectName}>
              <Card
                actions={[
                  <Icon type="edit" onClick={editSkill(item.projectID)} />,
                  <Popconfirm
                    placement="bottom"
                    title="Are you sure delete this project?"
                    onConfirm={confirm(item.projectID)}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Icon type="delete" />
                  </Popconfirm>
                ]}
              >
                <Meta
                  avatar={
                    <Avatar src="https://banner2.kisspng.com/20180331/cgq/kisspng-computer-icons-project-management-icon-design-prog-automation-5ac01c9db76b54.6923660315225396777513.jpg" />
                  }
                  title={item.projectName}
                />
                <div
                  style={{
                    marginTop: 13
                  }}
                >
                  Completion level :{" "}
                  <Progress percent={item.projectCompletionLevel} />
                </div>
                <div
                  style={{
                    marginTop: 2
                  }}
                >
                  Description : {item.projectDescription}{" "}
                </div>
                <div
                  style={{
                    marginTop: 2
                  }}
                >
                  <Icon type="team" />
                  Team : {item.projectTeam}{" "}
                </div>
                <div
                  style={{
                    marginTop: 10
                  }}
                >
                  {item.projectTechnologiesUsed.map(i => (
                    <Tag key={i} style={{ marginBottom: 5 }}>
                      {i.toUpperCase()}
                    </Tag>
                  ))}{" "}
                </div>
              </Card>
            </List.Item>
          );
        }

        return (
          <List.Item>
            <Button onClick={showModal} type="dashed" className="sdd">
              <Icon type="plus" />
              Add new project
            </Button>
          </List.Item>
        );
      }}
    />
  );
}
